export default {
  methods: {
    /**
     * @name 提交信息
     * @param modules
     */
    async submitForm(modules = Object) {
      const isSuper = this.getModuleProp(modules, 'isSuper');
      const saveUrl = this.moduleInfo['save_url'];
      if (isSuper) {
        await this.submitAllForm(saveUrl)
      } else {
        await this.submitOneForm(saveUrl, modules.id)
      }
    },

    // 超级提交 - 提交所有信息
    async submitAllForm(saveUrl = this.moduleInfo.save_url) {
      const formDataAll = await this.getFormData(true)
      await this.submitHttps(saveUrl, formDataAll)
      this.submitOk(formDataAll, true)
    },

    // 单个提交 -- 提交一级模块
    async submitOneForm(saveUrl, moduleId) {
      const formDataOne = await this.getFormData(moduleId, true)
      await this.submitHttps(saveUrl, formDataOne)
      this.submitOk(formDataOne, false)
    },

    // 提交
    async submitHttps(saveUrl, submitData) {
      let params = {
        bizParams: this.bizParams,
        viewModels: submitData,
        extraParams: this.extraParams
      }

      if (!saveUrl) {
        this.$message.error('请设置模板的saveUrl属性')
      }

      this.loading = true
      const res = await this.$EdFrame.postAction(saveUrl, params)
      if (res.code === 0) {
        this.$message.success(res.message || '保存成功!')
      } else {
        this.$message.error(res.message || '保存失败!')
      }
      this.loading = false
    }
  }
}
